import React from "react";
import {
  Container,
  InputWrapper,
  InputElement,
  Placeholder,
  ErrorMessage,
} from "./Input.styles";

type InputProps = {
  value?: string;
  className?: string;
  showError: boolean;
  errorMessage?: string;
  placeholder: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  ariaLabel?: string;
  id?: string;
  name?: string;
};

export default ({
  value,
  className,
  showError,
  errorMessage,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  ariaLabel,
  id,
  name,
}: InputProps) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const [hasValue, setHasValue] = React.useState(false);
  const [hasBeenFocused, setHasBeenFocused] = React.useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setHasValue(e.target.value !== "");
    onChange?.(e);
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    if (!hasBeenFocused) {
      setHasBeenFocused(true);
    }
    onFocus?.(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  return (
    <Container>
      <InputWrapper className={className}>
        <Placeholder
          isFocused={isFocused}
          hasValue={hasValue}
          showError={showError}
          hasBeenFocused={hasBeenFocused}
        >
          {placeholder}
        </Placeholder>
        <InputElement
          value={value}
          placeholder={isFocused ? undefined : placeholder}
          showError={showError}
          hasValue={hasValue}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          aria-label={ariaLabel}
          id={id}
          name={name}
        />
      </InputWrapper>
      {showError && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Container>
  );
};
